module.exports = __webpack_public_path__ + "img/DeaconBoard.c07fe68b.jpg";